import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { useSelector, useDispatch } from "react-redux";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { orderActions } from "../../../_store";
import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";

const AuditTrailReport = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const auditTrailList = useSelector((x) => x.order.auditTrailListReport);

  const [finalTableData, setFinalTableData] = useState([]);
  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  useEffect(() => {
    dispatch(orderActions.getAuditTrailReport());
  }, [dispatch]);

  const COLUMNS = [
    { Header: "Order Number", accessor: "OrderNumber", Filter: ColumnFilter },
    { Header: "Product Name", accessor: "ProductName", Filter: ColumnFilter },

    { Header: "Product SKU", accessor: "SKU", Filter: ColumnFilter },
    {
      Header: "Product Per Box",
      accessor: "ProductPerBoxCount",
      Filter: ColumnFilter,
    },
    {
      Header: "Order Per Box",
      accessor: "OrderPerBoxCount",
      Filter: ColumnFilter,
    },
    { Header: "Approval By", accessor: "ApprovalBy", Filter: ColumnFilter },
    {
      Header: "Approval DateTime",
      accessor: "CreatedDateStr",
      Filter: ColumnFilter,
      fieldType: "Date",
    },
  ];

  const generateColumns = [
    { header: "Order Number", dataKey: "OrderNumber" },
    { header: "Product Name", dataKey: "ProductName" },
    { header: "Product SKU", dataKey: "SKU" },
    { header: "Product Per Box", dataKey: "ProductPerBoxCount" },
    { header: "Order Per Box", dataKey: "OrderPerBoxCount" },
    { header: "Approval By", dataKey: "ApprovalBy" },
    { header: "Approval DateTime", dataKey: "CreatedDateStr" },
  ];

  const generateExcelColumns = [
    "Order Number",
    "Product Name",
    "Product SKU",
    "Product Per Box",
    "Order Per Box",
    "Approval By",
    "Approval DateTime",
  ];

  const columnStyles = {
    OrderNumber: { halign: "center", cellWidth: 40 },
    ProductName: { halign: "center", cellWidth: 40 },
    SKU: { halign: "center", cellWidth: 40 },
    ProductPerBoxCount: { halign: "center", cellWidth: 40 },
    OrderPerBoxCount: { halign: "center", cellWidth: 40 },
    ApprovalBy: { halign: "center", cellWidth: 40 },
    CreatedDateStr: { halign: "center", cellWidth: 40 },
  };

  const newTableData = finalTableData.map((obj) => ({
    OrderNumber: obj.OrderNumber,
    ProductName: obj.ProductName,
    SKU: obj.SKU,
    ProductPerBoxCount: obj.ProductPerBoxCount,
    OrderPerBoxCount: obj.OrderPerBoxCount,
    ApprovalBy: obj.ApprovalBy,
    CreatedDateStr: obj.CreatedDateStr,
  }));

  const handleClickPDF = () => {
    generatePDF(
      finalTableData,
      generateColumns,
      true,
      "Audit Trail Report",
      columnStyles
    );
  };

  const handleClickExcel = () => {
    generateXlsx(newTableData, generateExcelColumns, "Audit Trail Report");
  };

  const columns = useMemo(() => COLUMNS, []);

  return (
    <>
      <PageTitle activeMenu="Audit Trail Report" motherMenu="Order" />
      <ToastContainer />

      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Audit Trail Report</h4>
          <div className="float-sm-end">
            <Button
              className="me-2"
              variant="danger btn-rounded"
              onClick={handleClickPDF}
            >
              <span className="btn-icon-start text-danger">
                <i className="fa fa-solid fa-file-pdf"></i>
                {/* <i className="fa fa-regular fa-file-excel"></i> */}
              </span>
              PDF
            </Button>
            <Button
              className="me-2"
              variant="secondary btn-rounded"
              onClick={handleClickExcel}
            >
              <span className="btn-icon-start text-secondary">
                {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                <i className="fa fa-regular fa-file-excel"></i>
              </span>
              Excel
            </Button>
          </div>
        </div>

        <div className="card-body">
          <Table
            columns={columns}
            data={auditTrailList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>

      {loader}
    </>
  );
};

export default AuditTrailReport;
